(() => {
  const widgetSelector = '.mr-embedded-widget--vd.mr-embedded-widget--tile';
  const subtitleCopy = 'Discount applies automatically at your selected quantity';
  let selectedIndex = null;

  const numberParts = (text) => {
    const matches = String(text || '').match(/[\d,.]+/g) || [];
    return matches.map((value) => Number(value.replace(/,/g, '')));
  };

  const currencyPrefix = (text) => String(text || '').replace(/[\d\s,.-]/g, '').trim();

  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const minimumQuantity = (button) => {
    const values = numberParts(button.querySelector('.mr-quantity-option_text')?.textContent);
    return values[0] || 1;
  };

  const updateSavings = (widget, button) => {
    const bar = widget.querySelector('.monk-volume-savings');
    if (!bar || !button) return;

    const originalText = button.querySelector('.mr-quantity-option_price-text')?.textContent || '';
    const offerText = button.querySelector('.mr-quantity-option_offer-price-text')?.textContent || '';
    const original = numberParts(originalText)[0];
    const offer = numberParts(offerText)[0];
    const quantity = minimumQuantity(button);

    if (Number.isFinite(original) && Number.isFinite(offer)) {
      const savings = Math.max(0, (original - offer) * quantity);
      const prefix = currencyPrefix(offerText) || currencyPrefix(originalText);
      setText(bar.querySelector('strong'), `You're saving ${prefix}${savings.toLocaleString()}`);
      setText(bar.querySelector('.monk-volume-savings__quantity'), `${quantity}x products at this quantity`);
    }
  };

  const activate = (widget, button) => {
    widget.querySelectorAll('.mr-quantity-option').forEach((option) => {
      option.classList.toggle('monk-volume-active', option === button);
    });
    updateSavings(widget, button);
  };

  const enhanceWidget = (widget) => {
    const options = [...widget.querySelectorAll('.mr-quantity-option')];
    if (!options.length) return;

    const nativeBanner = options.find((option) => {
      return minimumQuantity(option) !== 6 && option.querySelector('.mr-quantity-option__banner-con');
    })?.querySelector('.mr-quantity-option__banner-con');

    options.forEach((option) => {
      const quantity = minimumQuantity(option);
      setText(option.querySelector('.mr-quantity-option_text'), `${quantity} - Pack`);

      let banner = option.querySelector('.mr-quantity-option__banner-con');
      if (quantity === 6 && nativeBanner && !banner?.dataset.monkNativeClone) {
        const replacement = nativeBanner.cloneNode(true);
        replacement.dataset.monkNativeClone = 'true';
        if (banner) banner.replaceWith(replacement);
        else option.appendChild(replacement);
        banner = replacement;
      }

      if (banner) {
        const bannerCopy = quantity === 6 ? 'FREE SHIPPING' : 'FREE SHIPPING + GIFT';
        setText(banner.querySelector('.mr-quantity-option__banner-text'), bannerCopy);
        if (banner.parentElement !== option) option.appendChild(banner);
      }

    });

    const heading = widget.firstElementChild;
    widget.querySelectorAll('[data-monk-custom-subtitle]').forEach((subtitle) => subtitle.remove());

    const backendSubtitle = [...widget.querySelectorAll('p, div, span')].find((element) => {
      return element.children.length === 0 && element.textContent.trim().toLowerCase() === subtitleCopy.toLowerCase();
    });
    if (backendSubtitle) backendSubtitle.classList.add('monk-volume-subtitle');

    if (!widget.querySelector('.monk-volume-savings')) {
      const savings = document.createElement('div');
      savings.className = 'monk-volume-savings';
      savings.innerHTML = `<div><strong>Select a quantity to see your savings</strong><span class="monk-volume-savings__quantity">Volume discount</span></div><span class="monk-volume-savings__note">Applied at cart</span>`;
      widget.appendChild(savings);
    }

    const visuallySelected = options.find((button) => {
      const style = getComputedStyle(button);
      return style.backgroundColor !== 'rgb(255, 255, 255)' && style.backgroundColor !== 'rgba(0, 0, 0, 0)';
    });

    if (selectedIndex !== null && options[selectedIndex]) {
      activate(widget, options[selectedIndex]);
    } else if (visuallySelected) {
      selectedIndex = options.indexOf(visuallySelected);
      activate(widget, visuallySelected);
    }
  };

  const enhanceAll = () => document.querySelectorAll(widgetSelector).forEach(enhanceWidget);

  document.addEventListener('click', (event) => {
    const clicked = event.target.closest(`${widgetSelector} .mr-quantity-option`);
    if (!clicked) return;

    const widget = clicked.closest(widgetSelector);
    const index = [...widget.querySelectorAll('.mr-quantity-option')].indexOf(clicked);
    selectedIndex = index;
    activate(widget, clicked);

    // Monk re-renders its cards after a selection, so apply the visual state
    // to the replacement button once the app has finished its own update.
    window.setTimeout(() => {
      const currentWidget = document.querySelector(widgetSelector);
      const currentButton = currentWidget?.querySelectorAll('.mr-quantity-option')[index];
      if (currentWidget && currentButton) activate(currentWidget, currentButton);
    }, 100);
  }, true);

  enhanceAll();
  new MutationObserver(enhanceAll).observe(document.documentElement, { childList: true, subtree: true });
})();


